export const DEFAULT_FILTER_PARAMETERS = {
  summary: true,
  include_plague_risks: true,
};
